import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import Link from '../Link'
import Button from '../Button/'

const AlternateFullImageText = ({ title, subtitle, components }) => {
  let defaultLableColor = '#b43996'

  return (
    <div className={`${styles.fullwidthWrapper}`}>
      <div className={styles.container}>
        <div>
          {components.map((card, idx) => {
            return (
              <div className={`${styles.card} ${styles.imageCard}`} key={idx}>
                <div className={styles.imageBox}>
                  {card.image != null && (
                    <GatsbyImage
                      image={card.image.gatsbyImageData}
                      objectFit="cover"
                      className={styles.cardImg}
                      alt={card?.image?.description}
                    />
                  )}
                </div>
                <div className={styles.innerContainer}>
                  <div className={styles.textCard}>
                    <h2>{card.title}</h2>
                    <h4
                      style={{
                        color:
                          card.subtitle.subtitle.split('\n')[0].split(';')
                            .length > 1
                            ? card.subtitle.subtitle
                                .split('\n')[0]
                                .split(';')[1]
                            : defaultLableColor,
                      }}
                    >
                      {card.subtitle.subtitle.split('\n')[0].split(';')[0]}
                    </h4>
                    <div className="paragraph">
                      {card.subtitle.subtitle.split('\n')[1]}
                    </div>
                    {card.ctaUrl && card.ctaText && (
                      <div className={styles.buttonContainer}>
                        <Link to={card.ctaUrl}>
                          <Button className={styles.joinUsButton}>
                            {card.ctaText}
                          </Button>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default AlternateFullImageText
